// デバイス情報の型定義
export interface DeviceInfo {
  isIOS: boolean;
  isAndroid: boolean;
  isChrome: boolean;
  isSafari: boolean;
  isEdge: boolean;
  isMobile: boolean;
  deviceBrowserCode: number;
}

/** UA から得るデバイス×ブラウザ識別子（`detectDeviceAndBrowser` と一致） */
export enum DeviceBrowserCode {
  OTHER = 0,
  PC_CHROME = 1,
  PC_SAFARI = 2,
  PC_EDGE = 3,
  PC_OTHER = 4,
  IOS_CHROME = 5,
  IOS_SAFARI = 6,
  ANDROID_CHROME = 7,
  ANDROID_SAFARI = 8,
  MOBILE_OTHER = 9,
}
